.forgotPasswordForm {
  display: flex;
  flex-direction: column;
}
.forgotPasswordForm > * + * {
  margin-top: var(--cxy-spacing-2);
}
.forgotPasswordForm .helperText {
  margin-bottom: var(--cxy-spacing-6);
}
.forgotPasswordForm .buttonSection {
  margin-top: var(--cxy-spacing-2);
  padding-top: var(--cxy-spacing-2);
  margin-bottom: 8rem;
}
.forgotPasswordForm .buttonSection button {
  text-transform: uppercase;
  width: 100%;
}

.responseMessage {
  margin-top: var(--cxy-spacing-1);
}

.errorMessage {
  color: var(--cxy-color-content-error);
}
